module.exports = __webpack_public_path__ + "static/img/chartBorderBg1.c4bf466.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chartBorderBg1.png
// module id = pXQA
// module chunks = 1